module.exports = __webpack_public_path__ + "media/images/c-adminSidebarLink/deposit_diffs-345cc15f42e20452f4bac8b4c5133929.svg";